import { UpdateUserPersonalData } from "@smatchy/domains/user/domains/update-user-personal-data";
import { MessageData } from "./message-data";
import {ChatType} from "@smatchy/chat-domain";


export class ChatData {
  id: string;
  type: ChatType;
  name: string;
  avatarUrl: string;
  status: "active" | "muted" | "bloqued" | "invited" | "first_message";
  first_members: UpdateUserPersonalData[]
  new_messages: number;
  nb_members: number;
  last_message: MessageData;

  constructor(
    id: string,
    type: ChatType,
    name: string,
    avatarUrl: string,
    status: "active" | "muted" | "bloqued",
    first_members: UpdateUserPersonalData[],
    last_message: MessageData,
    new_messages = 0,
    nb_members = 0,
    ) {
    this.id = id;
    this.type = type;
    this.name = name;
    this.avatarUrl = avatarUrl;
    this.status = status;
    this.first_members = first_members
    this.last_message = last_message
    this.new_messages = new_messages
    this.nb_members = nb_members
  }
}
